// extracted by mini-css-extract-plugin
module.exports = {"header--grid":"grid_header--grid__kaumQ","header--grid__logo":"grid_header--grid__logo__S9trn"};